import { Box, useTheme } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import { cardClassIdentifier, collapseTextToggleCID } from './sharedCardStyles';

export interface CardRowProps {
  backdrop?: boolean;
  borderTop?: boolean;
}

/**
 * Used to divide a card in multiple rows
 */
const CardRow: FC<PropsWithChildren<CardRowProps>> = ({ backdrop, borderTop, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        '& &': {
          borderLeft: `solid 8px ${theme.palette.grey.xLight}`,
        },
        '&:last-of-type': {
          borderBottom: 0,
        },
        position: 'relative',
        backgroundColor: backdrop ? theme.palette.background.paper : undefined,
        borderTop: borderTop ? theme.greyBorder : undefined,
        [`.${cardClassIdentifier} > &:first-of-type`]: {
          borderTop: borderTop ? 0 : undefined,
        },
        [`& .${collapseTextToggleCID}`]: {
          background: backdrop
            ? `linear-gradient(to bottom, ${theme.palette.transparent.main} 0%, ${theme.palette.grey.xxLight} 30%, ${theme.palette.grey.xxLight} 100%)`
            : undefined,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default CardRow;
